const isProduction = process.env.ENV === 'production'

const SLACK_HOOKS_URL_DEFAULT =
  'https://hooks.slack.com/services/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'
const SLACK_HOOKS_URL_SP =
  'https://hooks.slack.com/services/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'
const SLACK_HOOKS_URL_RJ =
  'https://hooks.slack.com/services/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'
const SLACK_HOOKS_URL_MG =
  'https://hooks.slack.com/services/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'
const SLACK_HOOKS_URL_PR =
  'https://hooks.slack.com/services/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'
const SLACK_HOOKS_URL_PE =
  'https://hooks.slack.com/services/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'
const SLACK_HOOKS_URL_CE =
  'https://hooks.slack.com/services/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'
const SLACK_HOOKS_URL_CO =
  'https://hooks.slack.com/services/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'
const SLACK_HOOKS_URL_SC =
  'https://hooks.slack.com/services/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'
const SLACK_HOOKS_URL_RS =
  'https://hooks.slack.com/services/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'

const channelsByState = {
  SP: SLACK_HOOKS_URL_SP,
  RJ: SLACK_HOOKS_URL_RJ,
  MG: SLACK_HOOKS_URL_MG,
  PR: SLACK_HOOKS_URL_PR,
  PE: SLACK_HOOKS_URL_PE,
  CE: SLACK_HOOKS_URL_CE,
  CO: SLACK_HOOKS_URL_CO,
  SC: SLACK_HOOKS_URL_SC,
  RS: SLACK_HOOKS_URL_RS,
}

export const obtainMessageToPdvAlertChannel = ({
  pdvState,
  pdvCity,
  reason,
  partnerID,
  partnerName,
  partnerPhone,
}) => {
  return `PDV em *${pdvState}* - *${pdvCity}*, acabou de fechar a loja (${reason}).
Entre em contato com *${partnerID}* - *${partnerName}* pelo ${
    partnerPhone || '[sem telefone cadastrado]'
  }.`
}

const statesCO = ['AC', 'AM', 'RR', 'RO', 'MT', 'MS', 'DF', 'TO', 'GO']
const getChannelUrl = pdvStateCode => {
  if (statesCO.includes(pdvStateCode)) {
    return channelsByState.CO
  }
  return channelsByState[pdvStateCode] || SLACK_HOOKS_URL_DEFAULT
}

export const sendMessageToPdvAlertChannel = ({
  partnerID,
  partnerName,
  partnerPhone,
  pdvStateCode,
  pdvCity,
  reason,
}) => {
  const OUR_OWN_PDV_ID = '32'
  const isOurOwnPdv = OUR_OWN_PDV_ID === partnerID
  const channelUrl = getChannelUrl(pdvStateCode)
  const message = obtainMessageToPdvAlertChannel({
    pdvState: pdvStateCode,
    pdvCity,
    partnerID,
    partnerName,
    partnerPhone,
    reason,
  })

  if (isProduction && !isOurOwnPdv) {
    fetch(channelUrl, {
      method: 'POST',
      mode: 'no-cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text: message }),
    })
  }
}
